import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import { ReactComponent as ArrowLeft } from "assets/icons/arrow-left.svg";
import { Form } from "formik";

export const ArrowLeftIcon = styled(ArrowLeft)`
  width: 24px;
  height: 24px;
  path,
  .a {
    fill: #000;
  }
  cursor: pointer;
`;

export const Container = styled.main`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 400px;

  h1 {
    color: ${({ theme }) => theme.colors.blue};
    font-size: 1.4375rem;
    font-weight: bold;
    text-align: left;
    line-height: 18px;
    margin-bottom: 12px;
  }

  h2 {
    color: #5e5e5e;
    font-size: 0.9375rem;
    text-align: left;
    line-height: 26px;
    margin-bottom: 22px;
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    margin-top: 24px;
  }
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const InputsContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  button {
    margin-bottom: 20px;
  }
`;

export const TooltipTextImpactAmbient = styled(ReactTooltip)`
  padding: 21px 28px !important;
  opacity: 1 !important;
  max-width: 450px;
  width: 100%;

  & p {
    margin: 0;
    font-size: 14px;
    font-family: "Mangueira Bold";
    line-height: 22px;
  }

  & span {
    font-size: 14px;
    line-height: 22px;
  }

  & ul {
    margin: 0;
    padding-left: 15px;
  }

  & li {
    font-size: 14px;
    line-height: 22px;
  }

  & img {
    position: absolute;
    top: 22px;
    right: 20px;
  }

  @media (max-width: 768px) {
    padding: 10px 14px !important;
    max-width: 300px;

    ul {
      margin-top: 10px;
    }

    & img {
      top: 12px;
      right: 10px;
      width: 40px;
    }
  }
`;

export const TitleImpactAmbient = styled.span`
  font-size: 14px;
  font-family: "Mangueira Bold";
  line-height: 22px;
  color: ${({ theme }) => theme.colors.blue};
`;

export const TextImpactAmbient = styled.p`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 14px;
  line-height: 22px;
  width: fit-content;
  margin-top: 10px;
  cursor: pointer;

  & a {
    color: ${({ theme }) => theme.colors.blue};
    font-size: 14px;
    line-height: 22px;
    text-decoration-line: underline;
  }

  & svg {
    color: ${({ theme }) => theme.colors.blue};
    min-height: 20px;
    min-width: 20px;
    margin-left: 5px;
  }
`;

export const CorrespondetionSection = styled.section`
  margin-bottom: 30px;

  h1 {
    font-size: 16px;
    font-family: "Mangueira Bold";
    margin: 0;
    margin-bottom: 15px;
    color: #7a7a7a;
  }
`;

export const DaySection = styled.section`
  margin-bottom: 30px;

  h1 {
    font-size: 14px;
    font-family: "Mangueira Bold";
    margin: 0;
    margin-bottom: 15px;
    color: #7a7a7a;
  }

  input {
    display: none;
    height: 0;
    width: 0;
  }

  label {
    line-height: 30px;
    border: 1px solid #dadada;
    border-radius: 3px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: relative;
    color: #7a7a7a;
    cursor: pointer;
  }

  div {
    display: grid;
    grid-template-columns: repeat(6, 36px);
    grid-gap: 8px;
  }

  input[type="radio"]:checked + label {
    border: 2px solid #0000ff;
    color: #0000ff;
    background-color: #f4f7f7;
  }

  @media (max-width: 768px) {
    label {
      width: 32px;
      height: 32px;
      font-size: 12px;
    }

    div {
      grid-gap: 4px;
      grid-template-columns: repeat(6, 32px);
    }
  }
`;

export const MailSection = styled.section`
  margin-bottom: 28px;

  h1 {
    font-size: 14px;
    font-family: "Mangueira Bold";
    margin: 0;
    margin-bottom: 15px;
    color: #7a7a7a;
  }

  div {
    display: flex;
    flex-direction: row;

    input {
      height: 16px;
      width: 16px;
    }

    input[type="radio"]:after {
      height: 12px;
      width: 12px;
    }

    label {
      margin-left: 10px;
      margin-right: 29px;
      color: #7a7a7a;
      font-size: 14px;
      line-height: 16px;
      margin-bottom: 0;
    }
  }

  @media (max-width: 768px) {
    div {
      flex-direction: column;
      gap: 10px;

      div {
        flex-direction: row;

        label {
          margin-left: 0;
        }
      }
    }
  }
`;

export const TextBlockEmail = styled.p`
  font-size: 14px;
  line-height: 18px;
`;

export const EmailSection = styled.section`
  margin-bottom: 30px;
`;

export const AutomaticDebtSection = styled.section`
  h1 {
    font-size: 16px;
    font-family: "Mangueira Bold";
    margin: 0;
    margin-bottom: 15px;
    color: #7a7a7a;
  }

  p {
    font-size: 0.8125rem;
    color: black;
    max-width: 274px;
  }
`;

export const TermsSection = styled.section`
  display: flex;
  flex-direction: row;
  align-items: baseline;

  input {
    margin-right: 10px;
  }

  label {
    font-size: 0.8125rem;
    line-height: 16px;
    font-weight: 400;
  }

  a {
    cursor: pointer;
    font-size: 0.8125rem;
    line-height: 16px;
    font-weight: 400;
    text-decoration: none;
    color: #148ad9 !important;
  }
`;

export const Text = styled.div`
  color: #000;
  font-size: 14px;
  font-weight: bold;
  margin-left: 10px;
  cursor: pointer;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
`;

export const Error = styled.span`
  color: #dc3545;
`;

export const EditAddressSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;

  span {
    margin-left: 10px;
    color: #7a7a7a;
    font-size: 14px;
    line-height: 16px;
    cursor: pointer;
  }

  svg {
    color: ${({ theme }) => theme.colors.blue};
  }

  @media (max-width: 768px) {
    justify-content: flex-end;
  }
`;

export const InfoContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 10px 15px;

  > div {
    display: flex;
    flex-direction: column;
  }
`;

export const Label = styled.span`
  font-size: 14px;
  font-family: "Mangueira Bold";
  margin: 0;
  margin-bottom: 5px;
  color: #7a7a7a;
`;

export const Info = styled.span`
  color: #7a7a7a;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 0;
  word-break: break-all;
`;

export const Action = styled.div`
  svg {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.blue};
  }
`;

export const BlockEmail = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  flex-flow: wrap;
  gap: 5px;
`;

export const Title = styled.div`
  font-size: 14px;
  font-family: "Mangueira Bold";
  margin: 0;
  color: #7a7a7a;
`;

export const Email = styled.p`
  font-size: 14px;
  margin: 0;
`;

export const Badge = styled.div`
  padding: 5px 10px;
  border-radius: 3px;
  background: #ffb300;
  color: #fff;
  font-size: 0.7rem;
  margin-bottom: 20px;
  display: inline-block;
`;

export const Messenger = styled.span`
  font-size: 0.8125rem;
  color: #8f8f8f;
  margin-bottom: 20px;
  display: inline-block;
`;

export const Tooltip = styled.label`
  position: relative;
  margin-top: 15px;
  color: ${({ theme }) => theme.colors.darkBlue};
  display: flex;
  align-items: center;
  font-weight: 400;
  justify-content: flex-end;

  div {
    cursor: pointer;
    display: flex;
    place-items: center;
  }

  button {
    margin-left: 12px;
    color: white;
    background-color: #f0b01b;
    border: none;
    border-radius: 100%;
    height: 15px;
    width: 15px;

    font-size: 11px;
    font-weight: bold;
    display: flex;
    place-content: center;
    outline: none;
  }

  #question {
    background-color: white;
    color: #363636;
    border-radius: 5px;
    font-size: 12px;
    opacity: 1;
    max-width: 382px;
    border: 1px solid #cfcfcf;
  }

  .__react_component_tooltip.type-dark.place-top:after {
    border-top-color: #cfcfcf !important;
  }
`;

export const Alert = styled.div`
  background: #ffe8aa;
  border: 2px solid #ff9100;
  padding: 10px 15px;
  border-radius: 10px;
  font-size: 14px;
  color: #ff5700;
  display: flex;
  margin-bottom: 20px;
`;

export const AlertIcon = styled.div`
  &:before {
    content: "!";
    display: block;
    width: 20px;
    height: 20px;
    font-size: 13px;
    line-height: 17px;
    font-weight: bolder;
    text-align: center;
    border: 2px solid;
    border-radius: 15px;
    color: #ff5700;
    margin-top: 5px;
    margin-right: 13px;
  }
`;
